import styled from 'styled-components';
import { colorUsage, getSpacing, gradientText, typography, zIndex } from 'stylesheet';
import { Close, Crop, Picture } from 'theme/icons';
var Title = styled.h1.withConfig({
  displayName: "ImageDialogstyle__Title",
  componentId: "sc-vg69ap-0"
})(["", " ", ""], typography.h1, gradientText);
var CloseButton = styled(Close).withConfig({
  displayName: "ImageDialogstyle__CloseButton",
  componentId: "sc-vg69ap-1"
})(["position:absolute;right:", ";cursor:pointer;& path{fill:", ";}"], getSpacing(3), colorUsage.textColor);
var Description = styled.p.withConfig({
  displayName: "ImageDialogstyle__Description",
  componentId: "sc-vg69ap-2"
})(["margin-top:", ";text-align:center;"], getSpacing(1));
var ButtonContainer = styled.div.withConfig({
  displayName: "ImageDialogstyle__ButtonContainer",
  componentId: "sc-vg69ap-3"
})(["margin-top:", ";"], getSpacing(2));
var InputContainer = styled.div.withConfig({
  displayName: "ImageDialogstyle__InputContainer",
  componentId: "sc-vg69ap-4"
})(["width:100%;margin-top:", ";"], getSpacing(2));
var Img = styled.img.withConfig({
  displayName: "ImageDialogstyle__Img",
  componentId: "sc-vg69ap-5"
})(["max-width:100%;height:auto;"]);
var PictureIcon = styled(Picture).withConfig({
  displayName: "ImageDialogstyle__PictureIcon",
  componentId: "sc-vg69ap-6"
})(["path{fill:", ";}"], colorUsage.paletteOverride.primary.main);
var CropIcon = styled(Crop).withConfig({
  displayName: "ImageDialogstyle__CropIcon",
  componentId: "sc-vg69ap-7"
})(["path{fill:", ";}"], colorUsage.paletteOverride.primary.main);
var ImgHover = styled.div.withConfig({
  displayName: "ImageDialogstyle__ImgHover",
  componentId: "sc-vg69ap-8"
})(["position:absolute;z-index:", ";display:none;align-items:center;justify-content:center;width:100%;height:100%;"], zIndex.buttonHover);
var HoverButtonContainer = styled.div.withConfig({
  displayName: "ImageDialogstyle__HoverButtonContainer",
  componentId: "sc-vg69ap-9"
})(["display:flex;gap:", ";"], getSpacing(3));
var PreviewContainer = styled.div.withConfig({
  displayName: "ImageDialogstyle__PreviewContainer",
  componentId: "sc-vg69ap-10"
})(["position:relative;display:flex;justify-content:center;width:400px;margin:", " auto;&:hover{", "{display:flex;}", "{opacity:0.6;}}"], getSpacing(3), ImgHover, Img);
export default {
  ButtonContainer: ButtonContainer,
  CloseButton: CloseButton,
  Description: Description,
  InputContainer: InputContainer,
  Title: Title,
  PreviewContainer: PreviewContainer,
  Img: Img,
  PictureIcon: PictureIcon,
  CropIcon: CropIcon,
  ImgHover: ImgHover,
  HoverButtonContainer: HoverButtonContainer
};